document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get('pq-cart-recommend')) {
    customElements.define(
      'pq-cart-recommend',
      class PqCartRecommend extends HTMLElement {
        constructor() {
          super();
          this.recommendContainer = null;
          this.observer = null;
          this.handleIntersection = this.handleIntersection.bind(this);
          this.recommendMainContainer = null;
        }

        connectedCallback() {
          this.recommendContainer = this.querySelector('.cart-recommendations');
          this.recommendMainContainer = this.querySelector('.recommend-main-container');
          if (!this.recommendContainer) return;

          // 配置 IntersectionObserver
          this.observer = new IntersectionObserver(this.handleIntersection, {
            rootMargin: '0px 0px 200px 0px',
          });

          this.observer.observe(this.recommendContainer);
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }
        }

        async handleIntersection(entries) {
          const entry = entries[0];
          if (!entry.isIntersecting) return;

          // 停止观察目标元素
          this.observer.unobserve(entry.target);

          try {
            const response = await fetch(entry.target.dataset.url);
            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const recommendations = doc.querySelector('.cart-recommendations');
            const recommendMainContainer = doc.querySelector('.recommend-main-container');
            if (recommendations?.innerHTML.trim()) {
              this.recommendContainer.innerHTML = recommendations.innerHTML;
              this.recommendMainContainer.innerHTML = recommendMainContainer.innerHTML;
              // 触发自定义事件通知外部
              this.dispatchEvent(
                new CustomEvent('recommendations-loaded', {
                  bubbles: true,
                  detail: { container: this.recommendContainer },
                })
              );
            }
          } catch (error) {
            console.error('Failed to load recommendations:', error);
            this.dispatchEvent(
              new CustomEvent('recommendations-error', {
                bubbles: true,
                detail: { error },
              })
            );
          }
        }
      }
    );
  }
});
